import type { InputHTMLAttributes, ReactNode } from "react";
import { cx } from "../cx";

/**
 * One radio with the 12px ring of the Casting list. The native input stays in
 * the tree (visually hidden) so keyboard and screen readers work unchanged.
 */
export function Radio({
  label,
  description,
  className = "",
  checked,
  ...rest
}: Omit<InputHTMLAttributes<HTMLInputElement>, "type"> & {
  label: ReactNode;
  description?: ReactNode;
}) {
  return (
    <label
      data-component="Radio"
      className={cx(
        "inline-flex cursor-pointer items-start gap-2.5 text-ui",
        rest.disabled && "cursor-not-allowed opacity-60",
        className,
      )}
    >
      <input {...rest} type="radio" checked={checked} className="peer sr-only" />
      <span
        aria-hidden="true"
        className={cx(
          "mt-0.5 box-border h-3 w-3 shrink-0 rounded-full border bg-surface peer-focus-visible:outline-2 peer-focus-visible:outline-accent peer-focus-visible:outline-offset-2",
          checked ? "border-4 border-accent" : "border-line-strong",
        )}
      />
      <span className="flex flex-col">
        <span className="font-medium text-ink">{label}</span>
        {description ? <span className="text-ink-2">{description}</span> : null}
      </span>
    </label>
  );
}
